<template>
  <div class="app">
    <transition-group tag="ul" name="image" style="margin:0px;padding:0px;">
      <li v-for="(items,index) in list" v-show="index===num" :key="index">
        <img :src="items" alt />
      </li>
    </transition-group>
    <div class="login" @click="gohome"></div>
  </div>
</template>

<script>
import G2World from "./g2world.vue";
import svgprogress from "svg-progress-bar";
export default {
  name: "Index",
  components: {
    G2World,
    svgprogress
  },
  data() {
    return {
      data: ["1", "2", "3", "4"],
      time: "",
      num: 0,
      list: [
        require("@/assets/login/fp1.png"),
        require("@/assets/login/fp2.png"),
        require("@/assets/login/fp3.png"),
        require("@/assets/login/fp4.png")
      ]
    };
  },
  props: {},
  created: function () {
    this.play();
  },
  methods: {
    gohome() {
      this.$router.push({ path: "/home" });
    },
    play() {
      this.time = setInterval(() => {
        this.num++;
        if (this.num == 4) {
          this.num = 0;
        }
      }, 9000);
    },
    change(i) {
      this.num = i;
    },
    stop() {
      clearInterval(this.time);
    },
    move() {
      //this.play();
    },
  },
  destroyed(){
    this.stop()
  }
};
</script>

<style scoped>
@import url("../assets/css3d/htmleaf-demo.css");
@import url("../assets/css3d/normalize.css");
.app {
  width: 2880px;
  height: 1080px;
  display: flex;
  justify-content: center;
}
.login {
  position: absolute;
  top: 758px;
  left: 246px;
  width: 482px;
  height: 114px;
  /* background: url("../assets/enter.png") no-repeat; */
  z-index: 1;
  cursor: pointer;
}
img {
  width: 100%;
  height: 100%;
}
li {
  width: 100%;
  height: 100%;
  border: 0px solid white;
  color: white;
  position: absolute;
}
ul {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}
.nav {
  background-color: #c3c3c3;
  color: white;
  font-size: 20px;
  border-radius: 50%;
  margin-bottom: 10px;
  opacity: 0.5;
}
.active {
  opacity: 1;
}
.image-enter-active {
  transition: all 2s linear;
}
.image-leave-active {
  transition: all 2s linear;
}
.image-enter-to {
  transform: translateY(0);
}
.image-enter {
  transform: translateY(100%);
}
.image-leave {
  transform: translateY(0);
}
.image-leave-to {
  transform: translateY(-100%);
}
</style>
